import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon } from '@paypalcorp/pp-react';
import { grey600 } from '@paypalcorp/pp-react-colors';

function SocialShareTwitter({
  url,
  handleSocialLinkClick,
  linkTitle,
  color = grey600,
}) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'twitter')}
      title={linkTitle}
      style={{ color }}
      data-testid="social-share-twitter"
    >
      <Icon name="share-twitter" size="lg" />
    </Link>
  );
}

SocialShareTwitter.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.string,
};

export default SocialShareTwitter;
